import {useState} from "react";
import {Col} from "react-bootstrap";

export default function SchedulerBacklogColumn({
    boardHeight,
    children,
    emptyMessage,
    hasJobs,
    header,
    onClearFilter,
    onDropJob,
}) {
    const [isHighlighted, setIsHighlighted] = useState(false);

    return (
        <Col
            className="scheduler-backlog-column"
            onDragOver={(event) => {
                event.preventDefault();
                setIsHighlighted(true);
            }}
            onDragLeave={() => setIsHighlighted(false)}
            onDrop={(event) => {
                event.preventDefault();
                setIsHighlighted(false);
                onDropJob(event);
            }}
            style={{
                height: boardHeight,
                border: isHighlighted ? "3px dashed darkBlue" : "3px dashed transparent",
            }}
        >
            {header ? <div style={{marginBottom: "20px"}}>{header}</div> : null}
            {hasJobs ? children : (
                <div
                    style={{
                        height: "200px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <span>
                        {emptyMessage}
                        <br/>
                        <button
                            type="button"
                            className="btn btn-link p-0 align-baseline"
                            onClick={onClearFilter}
                        >
                            Try Clear Filter
                        </button>
                    </span>
                </div>
            )}
        </Col>
    );
}
